import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { SummaryView, PlanAttributes } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { savePlanIdForEnrollment } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { NgRedux } from '@ptl/angular-redux-store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-whb-banner',
    templateUrl: './whb-banner.component.html',
    styleUrls: ['./whb-banner.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class WhbBannerComponent extends GlobalShadowStyleDirective implements OnInit {
  @Input() enrollStartUrl: string;
  isPlanChange = false;
  constructor(
    private ngRedux: NgRedux<any>,
    private snackBar: MatSnackBar,
  ) { 
    super();
  }

  @Input() plan: Product<PlanAttributes, SummaryView>;

  ngOnInit() { }
  goToEnrollFlow() {
    this.ngRedux.dispatch(savePlanIdForEnrollment('whb_addon'));
    if (this.enrollStartUrl) {
      const alertDuration = 1000; // ms

      this.snackBar.open(`Saving Information`, 'OK', {
        duration: alertDuration,
        panelClass: 'positive-panel-class'
      });

      setTimeout(() => {
        window.location.href = `./${this.enrollStartUrl}`;
      }, alertDuration);
    }
  }
}
